/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Saga for Settings components
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.3.0
 */

import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';

import { settingsLabelsSagas } from './components/SettingsLabels/settingsLabelsSagas';
import { settingsPositionsSagas } from './components/SettingsPositions/settingsPositionsSagas';
import { settingsProfileSaga } from './components/SettingsProfile/settingsProfileSagas';

export function* settingsSaga(): SagaIterator {
    yield fork(settingsLabelsSagas);
    yield fork(settingsPositionsSagas);
    yield fork(settingsProfileSaga);
}
